import React, { type ReactNode, createContext, useContext } from 'react';
import configEntries from 'app/config/entries';

export type Config = {
  REACT_APP_ENVIRONMENT: string;
  REACT_APP_API_ENVIRONMENT: string;
  REACT_APP_AUTH_CLIENT_ID: string;
  REACT_APP_AUTH_CLIENT_SECRET: string;
  REACT_APP_AUTH_URL: string;
  REACT_APP_COGNITO_EXCHANGE_URL: string;
  REACT_APP_HYROX_API_URL: string;
  REACT_APP_PASSWORD_URL: string;
  REACT_APP_FEEDBACK_URL: string;
  REACT_APP_LOCALISATION_ENABLED: boolean;
  REACT_APP_WHITEBOARD_ENABLED: boolean;
  REACT_APP_RESOURCE_LISTS_ENABLED: boolean;
  REACT_APP_SSO_ENABLED: boolean;
  REACT_APP_SSO_REDIRECT_URL: string;
  REACT_APP_SENTRY_DSN: string;
  REACT_APP_SENTRY_ENVIRONMENT: string;
  REACT_APP_BANNER_LINK_URL: string;
  REACT_APP_BANNER_IMAGE_URL: string;
  REACT_APP_MOBILE_BANNER_IMAGE_URL: string;
  REACT_APP_ROOT_RESOURCE_LIST_ID: string;
  REACT_APP_ROOT_COLLECTION_LIST_ID: string;
  REACT_APP_NEW_LIBRARY_ENABLED: boolean;
  REACT_APP_AMPLITUDE_API_KEY: string;
  REACT_APP_THAI_ENABLED: string;
  REACT_APP_SUBTITLES_ENABLED: boolean;
  REACT_APP_PERSONALISED_HOMESCREEN_ENABLED: boolean;
  REACT_APP_TOKEN_VERIFICATION_URI: string;
  REACT_APP_TOKEN_INTROSPECT_URL: string;
  REACT_APP_ONE_FIIT_CLIENT_ID: string;
  REACT_APP_AUTH_CODE_URL: string;
  REACT_APP_AUTH_CODE_NO_REDIRECT_URL: string;
  REACT_APP_AUTH_CALLBACK_REDIRECT_URL: string;
  REACT_APP_HYROX_CLIENT_ID_FOR_ONE_FIIT: string;
  REACT_APP_WORKOUT_BUILDER_URL: string;
  REACT_APP_CLIENT_ID_FOR_ONE_FIIT: string;
  REACT_APP_WHITEBOARD_URL: string;
  REACT_APP_PROGRESSIVE_PLANS_ENABLED: boolean;
  REACT_APP_WORKOUTS_HOMEPAGE_ENABLED: boolean;
  REACT_APP_GYM_FINDER_LEADS_ENABLED: boolean;
  REACT_APP_RECORD_RELAY_URL: string;
  REACT_APP_RECORD_RELAY_API_KEY: string;
};

type RawConfigValue = {
  value: any;
  defaultValue?: any;
  format?: (value: any) => any;
};

const configContext = {
  config: Object.entries<RawConfigValue>(configEntries).reduce(
    (formattedConfig, [key, { value, format, defaultValue }]) => ({
      ...formattedConfig,
      [key]: format ? format(value || defaultValue) : value || defaultValue,
    }),
    {},
  ) as Config,
};

export const { config } = configContext;

const context = createContext(configContext);

const { Provider } = context;

export const ConfigProvider = ({ children }: { children: ReactNode }) => (
  <Provider value={configContext}>{children}</Provider>
);

export default () => useContext(context);
